import { Box } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';

export default function AdminAssignmentsLayout() {
  return (
    <Box marginTop={-2} backgroundColor="white" overflow="hidden">
      <Outlet />
    </Box>
  );
}
